import React from 'react'
import styles from './style.module.less'
import store from './store'
import { Select } from 'hljd'
import Chat from '@common/Chat'

const Option = Select.Option

export default (luckStatus, draw_status) => [
  {
    title: '报名用户',
    dataIndex: 'name',
    key: 'name',
    width: 210,
    render: (name, { user, realname }) => {
      let img = 'http://qnm.hunliji.com/o_1am865g8eeqm1miicua18vf1ic67.png'
      if (user && user.avatar) {
        img = user.avatar + '?imageView2/1/w/64/'
      }
      return (
        <div className={styles.colImg}>
          <img src={img} style={{ width: 64, height: 64 }} />
          <span>{realname}</span>
        </div>
      )
    }
  },
  {
    title: (
      <Select
        value={luckStatus}
        style={{ width: 100 }}
        onChange={store.changeLuckStatus}
      >
        <Option value="">是否被抽中</Option>
        <Option value="1">被抽中</Option>
        <Option value="0">未被抽中</Option>
      </Select>
    ),
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <div>
        {status == 0 && <p style={{ color: '#ff705e' }}>未付款</p>}
        {status == 1 && draw_status == 0 && <p>待抽奖</p>}
        {status == 1 && draw_status == 1 && <p>未被抽中</p>}
        {status == 2 && (
          <div style={{ color: '#4bcf99' }}>
            <p>被抽中</p>
            <p style={{ color: '#999' }}>未兑换</p>
          </div>
        )}
        {status == 3 && (
          <div style={{ color: '#4bcf99' }}>
            <p>被抽中</p>
            <p style={{ color: '#ff705e' }}>已兑换</p>
          </div>
        )}
      </div>
    )
  },
  {
    title: '报名时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 100
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: 260,
    render: (remark, { id }) => (
      <div>
        <p>{remark}</p>
        <span>
          {remark ? (
            <span
              className={styles.remark}
              onClick={store.showRemarkModal(remark, id)}
            >
              修改
            </span>
          ) : (
            <span
              className={styles.remark}
              onClick={store.showRemarkModal('', id)}
            >
              添加
            </span>
          )}
        </span>
      </div>
    )
  },
  {
    title: '联系用户',
    dataIndex: 'tel',
    key: 'tel',
    render: (tel, { user, user_id }) => (
      <div>
        {tel}
        {tel.indexOf('*') > -1 ? (
          <p className={styles.remark} onClick={store.showTips}>
            私信用户
          </p>
        ) : (
          <p>{user_id && <Chat toUserId={user_id} />}</p>
        )}
      </div>
    )
  }
]
